var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "VueSelect",
        _vm._b(
          {
            ref: "multiselect",
            attrs: {
              clearSearchOnBlur: () => false,
              selectable: option => !option.disabled
            },
            on: {
              search: search => _vm.$emit("search", search),
              input: _vm.handleInput
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "option",
                  fn: function(option) {
                    return _vm.$scopedSlots.option
                      ? [_vm._t("option", null, null, option)]
                      : undefined
                  }
                }
              ],
              null,
              true
            )
          },
          "VueSelect",
          { ..._vm.$attrs, ..._vm.selectProps },
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }